import React from 'react';
import Column from 'shared/components/column';
import {SemiBoldText} from 'shared/components/text';
import useCart from '../util/use-cart';
import {useTheme} from 'styled-components';

const CartObservation: React.FC = () => {
  const {cart, setObservation} = useCart();
  const {colors} = useTheme();

  return (
    <Column gap={10}>
      <SemiBoldText>Observação do pedido</SemiBoldText>
      <textarea
        style={{
          height: 150,
          borderWidth: 1,
          borderColor: colors.inputBorder,
          borderRadius: 4,
          padding: 10,
        }}
        placeholder="Alguma observação para o pedido?"
        onChange={(e) => setObservation(e.target.value)}
        value={cart?.observation}
      />
    </Column>
  );
};

export default CartObservation;
